<footer class="site-footer">
  <div class="site-footer__inner">

    <div class="footer-col footer-col--brand">
      <img class="brand-mark" src="../../assets/images/osterby_dack_och_allservice_logotyp_600x232.png" alt="Österbydäck & Allservice">
      <div class="social-links">
        <a href="https://www.facebook.com/osterbydackochallservice/" aria-label="Facebook" target="_blank" rel="noopener">
          <img src="../../assets/images/fbooklogo.svg" alt="">
        </a>
        <a href="https://www.instagram.com/firststopsv/" aria-label="Instagram" target="_blank" rel="noopener">
          <img src="../../assets/images/instagramlogo.png" alt="">
        </a>
      </div>
    </div>

    <nav class="footer-col">
      <h3>Genvägar</h3>
      <ul>
        <li><a routerLink="/service">Service</a></li>
        <li><a routerLink="/tires">Däck</a></li>
        <li><a routerLink="/storage">Däckhotell &amp; Vinterförvaring</a></li>
        <li><a routerLink="/openinghours">Öppettider</a></li>
        <li><a routerLink="/findus">Hitta hit</a></li>
      </ul>
    </nav>

    <div class="footer-col">
      <h3>Kontakt</h3>
      <ul class="contact-list">
        <li><a href="tel:+4629521045">0295-210 45</a></li>
        <li>Bilverkstad: <a href="mailto:verkstad.osterbydack@hotmail.com">verkstad.osterbydack&#64;hotmail.com</a></li>
        <li>Däckverkstad: <a href="mailto:osterbydack@hotmail.com">osterbydack&#64;hotmail.com</a></li>
      </ul>
    </div>

    <div class="footer-col footer-col--badges">
      <div class="badge-row">
        <div class="badge-item">
          <img src="../../assets/images/soliditet.jpg" alt="Högsta kreditvärdighet">
          <span class="badge-caption">Högsta kreditvärdighet</span>
        </div>
      </div>
      <img class="klarna-logo" src="../../assets/images/klarna_logo.svg" alt="Klarna">
      <p class="payment-note">Hos oss kan du använda Klarna för att betala eller dela upp din betalning</p>
    </div>

  </div>

  <div class="site-footer__bottom">
    <p>&copy; {{ currentYear }} Österbydäck &amp; Allservice</p>
  </div>
</footer>
